import { render, staticRenderFns } from "./Protection-terms.vue?vue&type=template&id=56401a96"
import script from "./Protection-terms.vue?vue&type=script&lang=js"
export * from "./Protection-terms.vue?vue&type=script&lang=js"
import style0 from "./Protection-terms.vue?vue&type=style&index=0&id=56401a96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports